// DevExpress license configuration — committed fallback key.
//
// This file provides the license key that the build uses by default. Loaded by
// `devextreme-config.ts`, which is called from `portal.boot.ts` and
// `globalnotification.boot.ts` before each bootstrap.
//
// Production deployments can override at runtime by setting
// `window.DEVEXTREME_LICENSE_KEY` before the SPA loads (see devextreme-config.ts).
//
// To obtain or rotate the XMPro DevExpress license key:
// 1. Visit https://js.devexpress.com/Licensing/
// 2. Log in with the XMPro DevExpress account
// 3. Find the license key for the current DevExtreme major version
// 4. Replace the value below
//
// Note: the license key is specific to each major DevExtreme version. When SM2
// bumps DevExtreme to a new major, this file must be updated as well.

export const licenseKey =
    'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImFlZDEwNGY3LTA2MzItNDZjMC04ZTA1LTMxNzIzY2E4OGE1ZSIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUxCn0=.GnzZ2aHT8o3NQtk3LUpwhdwTgCqjHELGNZkMthkLXh3RoxM7zd90PpRIJ/MGThV/bp++TxoIOpQDJde6CphHMgI5oS32v0pfbR1u/PWW6cb3G5peg5JlYXJaU5HsS0hhaikPXA==';
